import {
	useCreateTagType,
	useDeleteTagType,
	useOrganisation,
	useUpdateTagType,
} from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";
import TaxonomyCrudEditor from "./TaxonomyCrudEditor";

/**
 * "Uppdragstaggar" — CRUD over the org's `jobTagTypes` taxonomy via the
 * dedicated tag-type endpoints. Purely descriptive labels (no validity);
 * distinct from job requirements, which gate matching.
 */
const UppdragstaggarPage = () => {
	const { data: organisation } = useOrganisation();
	const { mutateAsync: createTagType, isLoading: isCreating } = useCreateTagType();
	const { mutateAsync: updateTagType, isLoading: isUpdating } = useUpdateTagType();
	const { mutateAsync: deleteTagType, isLoading: isDeleting } = useDeleteTagType();

	return (
		<SettingsLeaf
			title="Uppdragstaggar"
			description="Beskrivande taggar som kan sättas på uppdrag och användas som filter i uppdragslistan. Påverkar inte matchningen."
		>
			<TaxonomyCrudEditor
				items={organisation?.jobTagTypes ?? []}
				addLabel="Lägg till tagg"
				emptyText="Inga uppdragstaggar har skapats ännu."
				showColor
				showListViewVisibility
				isSaving={isCreating || isUpdating || isDeleting}
				onCreate={({ name, color, showInListViews }) =>
					createTagType({ taxonomy: "job", name, color, showInListViews })
				}
				onUpdate={(key, { name, color, showInListViews }) =>
					updateTagType({ taxonomy: "job", key, name, color, showInListViews })
				}
				onDelete={(key) => deleteTagType({ taxonomy: "job", key })}
				deleteTitle={(item) => `Ta bort taggen "${item.name.sv}"?`}
				deleteDescription={() => "Taggen tas bort från alla uppdrag. Detta går inte att ångra."}
			/>
		</SettingsLeaf>
	);
};

export default UppdragstaggarPage;
